export default {
    tagPicker_allTagsAreSelected: "All tags"
}